import { Elm } from "./Main.elm"
import countrycodes from "./_external-data/json/country-by-abbreviation.json"
import countrycontinents from "./_external-data/json/country-by-continent.json"
import countrypopulations from "./_external-data/json/country-by-population.json"


// HELPERS
JSON.tryParse = function (value) {
    try {
        return JSON.parse(value);
    } catch (error) {
        console.log(`JSON.tryParse error: ${error}`);
        return null;
    }
};


function storageAvailable(type) {
    let storage;
    try {
        storage = window[type];
        const x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return (
            e instanceof DOMException &&
            e.name === "QuotaExceededError" &&
            // acknowledge QuotaExceededError only if there's something already stored
            storage &&
            storage.length !== 0
        );
    }
};
// END HELPERS

const APP_NAME = "FLAG_QUIZ_1";
const SETTINGS_HINTTIME = `${APP_NAME}.userSettings.hintTime`;

// flag data
let countries = []
for (let cc of countrycodes) {
    if (!cc.country) {
        continue;
    }
    let countryId = cc._country ?? cc.country;
    let continent = countrycontinents.find(item => item.country == countryId)?.continent ?? null;
    if (null == continent || "Antarctica" == continent) {
        //console.log("Continent not found for: " + cc.abbreviation + " " + cc.country);
        continue;
    }
    let population = countrypopulations.find(item => item.country == countryId).population
    countries.push({ name: cc.country, code: cc.abbreviation, continent: continent, population: population });
}

// init main
var app = Elm.Main.init(
    {
        node: document.getElementById("root")
        , flags: {
            countryDtos: countries
        }
    }
);

/*app.ports.persistSettings.subscribe(function (settings) {
    if (!storageAvailable("localStorage"))
        return;

    localStorage.setItem(SETTINGS_HINTTIME, JSON.stringify(settings.hintTime ?? null));
}); */


